import gTagConstants from '@/constants/gEvenets.constants';
import useBackendUser from '@/hooks/useBackendUser';
import event from '@/utilites/gTag';
import { deleteCookie } from 'cookies-next';
import { useEffect, useRef } from 'react';

export default function GTagEvents({
  recentlySignedIn,
  recentlySignedUp,
}: {
  recentlySignedIn: boolean;
  recentlySignedUp: boolean;
}) {
  const { data: user } = useBackendUser();
  const recentlySignedInRef = useRef<boolean>(false);
  const recentlySignedUpRef = useRef<boolean>(false);
  useEffect(() => {
    if (user) {
      if (recentlySignedIn && !recentlySignedInRef.current) {
        event(
          gTagConstants.eventKeys.recently_signed_in,
          {
            event_category: 'interaction',
            device: 'Website',
          },
          { userId: user.id, lang: user.local }
        );
      }
      if (recentlySignedUp && !recentlySignedUpRef.current) {
        event(
          gTagConstants.eventKeys.recently_signed_up,
          {
            event_category: 'interaction',
            device: 'Website',
          },
          { userId: user.id, lang: user.local }
        );
      }

      deleteCookie(gTagConstants.eventKeys.recently_signed_in);
      deleteCookie(gTagConstants.eventKeys.recently_signed_up);
    }
  }, [recentlySignedIn, recentlySignedUp, user]);

  return null;
}
